import { isDefined, isEmpty } from '@sgme/fp';
import { useData } from 'components/common-form/hooks/useData';
import { useFieldMetadata } from 'components/common-form/hooks/useFieldMetadata';
import { useFieldTranslationKey } from 'components/common-form/hooks/useFieldTranslationKey';
import { BlockOrientationFormGroup } from 'components/shared/FormGroup';
import { IntlKey } from 'locales';
import type { MultipleLabelFieldData, MultipleLabelFieldMetadata } from 'models/forms/fields';
import { FC } from 'react';

import type { ProductNodeBuilderProps } from '../ProductNodeBuilder.model';

const Label: FC<{ value: string | undefined; e2e: string }> = ({ value: label, e2e }) => (
  <input className="multiple-label-field form-control" type="text" readOnly value={label} data-e2e={e2e} />
);

export const MultipleLabelField: FC<ProductNodeBuilderProps> = ({ node: { id }, workspaceType }) => {
  const [data] = useData<MultipleLabelFieldData>(id);
  const { labels } = useFieldMetadata<MultipleLabelFieldMetadata>(id)!;
  const translationKey = useFieldTranslationKey(id);

  if (!isDefined(data)) {
    return null;
  }

  return (
    <BlockOrientationFormGroup inputId={id} label={`form.${translationKey}` as IntlKey} workspaceType={workspaceType}>
      {isEmpty(data) ? (
        <Label value={undefined} e2e={`${id}-no-value`} />
      ) : (
        data.map((code, index) => <Label value={labels[code] || code} key={index} e2e={`${id}-${code}`} />)
      )}
    </BlockOrientationFormGroup>
  );
};

MultipleLabelField.displayName = 'MultipleLabelField';
